import React, { createContext, useContext, useState } from "react";
const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [books, setBooks] = useState([]);
    const [oldBooks, setOldBooks] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [authors, setAuthors] = useState([]);

    return (
        <AppContext.Provider
            value={{
                books,
                setBooks,
                oldBooks,
                setOldBooks,
                testimonials,
                setTestimonials,
                authors,
                setAuthors
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => useContext(AppContext);